import React, { useState, useContext, useEffect } from "react";
import { FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import { TiDeleteOutline } from "react-icons/ti";

import ButtonUI from "../../material-ui/ButtonUI";
import { AuthContext } from "../../../context/Auth/AuthContext";
import "../../../styles/LinkPopup.css";

const DocumentViewer = ({ tableValues, changeDocumentViewerState }) => {
  return (
    <div className="single-link-popup-container">
      <ButtonUI
        formButton={false}
        variant="outlined"
        buttonText={<FaEye />}
        style={{
          backgroundColor: "#ffc107",
          color: " white",
          marginRight: "5px",
        }}
        onClickFunc={() =>
          changeDocumentViewerState(tableValues.docUrl, tableValues.title)
        }
      />
    </div>
  );
};

export default DocumentViewer;
